import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { withRouter } from '../../common/withRouter';
import {
  DataDefinitionList,
  Loader,
  Notification,
  Message,
  ButtonOBSOLETED
} from '../../web.common';
import AriaModal from 'react-aria-modal';
import { LayoutContext } from '../layout/siteLayout';
import PageTop from '../layout/PageTop';
import withApi from '../higherOrderComponents/withApi';
import {
  DisplayPercentage,
  DisplayDate,
  DisplayGuid,
  DisplayStatus
} from '../items';
import { DetailsRightBar, NoLink, Divider, Action, Link } from './DetailsRightBar';
import { purchaseParticipantStatus } from '../../enums/purchaseParticipantStatus';

class ParticipantInternal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      participantData: null
    };
  }

  async componentDidMount() {
    const { match: { params: { participantId } } } = this.props;
    const { api: { participants: { getParticipant } } } = this.props;

    try {
      const participantData = await getParticipant(participantId);
      this.setState({ participantData });
    }
    catch (e) {
      this.setState({ errorMessage: new Message('error', 'Unable to get data') });
    }
  }

  render() {
    const {
      match: { params: { participantId } },
      api: { purchases: { getPurchaseProduct } },
      history
    } = this.props;
    const { participantData, errorMessage, isConfirmingCancellation } = this.state;

    let mappedData = null;
    let purchaseProductId = null;

    if (participantData) {
      const {
        Id,
        CreatedAtCet,
        OccursAtCet,
        Status,
        MembershipSlots,
        InviteeName,
        InviterName,
        ParticipantsIndex,
        Reference,
        PurchaseProductId,
        UserId,
        RespondedAt,
        Category,
        FacilityId,
        SubcriptionId
      } = participantData;
      purchaseProductId = PurchaseProductId;

      mappedData = {
        Id: <DisplayGuid>{Id}</DisplayGuid>,
        Status: <DisplayStatus mapping={purchaseParticipantStatus}>{Status}</DisplayStatus>,
        'Membership Slots': MembershipSlots,
        'Invitee Name': InviteeName,
        'Inviter Name': InviterName,
        'Participant Index': <DisplayPercentage>{ParticipantsIndex}</DisplayPercentage>,
        'Created At (CET)': <DisplayDate>{CreatedAtCet}</DisplayDate>,
        'Responded At': <DisplayDate>{RespondedAt}</DisplayDate>,
        Reference,
        'Purchase Product Id': <DisplayGuid>{PurchaseProductId}</DisplayGuid>,
        'User Id': <DisplayGuid baseAnchor='/user'>{UserId}</DisplayGuid>,
        'Occurs At (CET)': <DisplayDate>{OccursAtCet}</DisplayDate>,
        Category,
        FacilityId: <DisplayGuid baseAnchor='/facility'>{FacilityId}</DisplayGuid>,
        SubcriptionId: <DisplayGuid baseAnchor='/subscription'>{SubcriptionId}</DisplayGuid>
      };
    }

    return (
      <LayoutContext.Consumer>
        {() => (
          <React.Fragment>
            {
              isConfirmingCancellation ? (
                // TODO: extract modal
                <AriaModal
                  titleText='Edit Field'
                  mounted
                  verticallyCenter={false}
                  focusDialog
                  getApplicationNode={() => document.getElementById('app')}
                  dialogClass='dialog-size-normal'
                  scrollDisabled
                >
                  <h3>Are you sure you want to proceed?</h3>

                  <ButtonOBSOLETED
                    buttonColor='danger'
                    size='small'
                    onClick={async () => {
                      const {
                        api: {
                          participants: {
                            cancelParticipant,
                            getParticipant
                          }
                        }
                      } = this.props;

                      this.setState({
                        isConfirmingCancellation: false,
                        participantData: null
                      });

                      try {
                        await cancelParticipant(participantId);
                      }
                      catch (e) {
                        this.setState({
                          errorMessage: new Message('error', `Unable to cancel participant: ${e}`)
                        });
                      }

                      const newParticipantData = await getParticipant(participantId);

                      this.setState({
                        isConfirmingCancellation: false,
                        participantData: newParticipantData
                      });
                    }}
                    disabled={false}
                    buttonContent='Cancel Participant'
                    ariaLabel='cancel participant'
                  >
                    Proceed
                  </ButtonOBSOLETED>
                  <br />
                  <ButtonOBSOLETED
                    buttonColor='gray'
                    size='small'
                    onClick={() => {
                      this.setState({ isConfirmingCancellation: false });
                    }}
                    disabled={false}
                    buttonContent='Back'
                    ariaLabel='cancel participant'
                  >
                    Back
                  </ButtonOBSOLETED>
                </AriaModal>
              ) : ''
            }
            <Notification newMessage={errorMessage} />

            <div className='content-with-right-pane-delimiter'>
              <PageTop
                documentTitle='Participant details'
                documentDescription='Participant details'
              />

              <h2 className='main-page-header main-page-header-with-subheader'>
                Participant
              </h2>
              <h5 className='main-page-subheader'>{participantId}</h5>
              <br />

              {
                mappedData ? (
                  <React.Fragment>
                    <DataDefinitionList
                      listData={mappedData}
                      classNames={['detail-page-list']}
                    />
                  </React.Fragment>
                ) : <Loader hasLoaded={false}>Loading...</Loader>
              }
            </div>

            <DetailsRightBar>
              <Divider>Links</Divider>
              <Action action={async () => {
                const { PurchaseId } = await getPurchaseProduct(purchaseProductId);
                history.push(`/purchase/${PurchaseId}`);
              }}
              >
                Purchase
              </Action>
              <Link to={`/participants?purchaseProductId=${purchaseProductId}`}>Other participants</Link>
              <Divider>Actions</Divider>
              <NoLink>None</NoLink>
            </DetailsRightBar>
          </React.Fragment>
        )}
      </LayoutContext.Consumer>
    );
  }
}

const Participant = withRouter(withApi(connect(({ user }) => ({ isLoggedIn: !!user }), {})(ParticipantInternal)));

Participant.requiresLogin = true;
Participant.propTypes = { isLoggedIn: PropTypes.bool };

export default Participant;
